var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "refund-details" }, [
    _c("div", { staticClass: "audit-content-details" }, [
      _c("div", { staticClass: "audit-content-details-title medium" }, [
        _vm._v("\n          Refund Details\n        ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "audit-content-details-text" }, [
        _c("div", [
          _c("div", { staticClass: "ash medium" }, [_vm._v("Brand")]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.orderInfo.brandName))])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "ash medium" }, [_vm._v("Order ID ")]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.orderInfo.uid))])
        ]),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "ash medium" }, [_vm._v("Order Placed ")]),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.orderInfo.payTime))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "audit-content-details-id" }, [
        _c("div", { staticClass: "audit-details-id-title" }, [
          _c("div", [
            _c("span", { staticClass: "ash medium" }, [
              _vm._v("Service Order ID")
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.serviceOrder.sid))])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "ash medium" }, [_vm._v("Create Date")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.serviceOrder.createAt))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "medium" }, [
            _c("span", { staticClass: "ash" }, [_vm._v("Refund Total")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "$" + _vm._s(_vm.serviceOrder.refundTotalAmount.toFixed(2))
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "audit-details-indent" }, [
          _c("div", [
            _c("span", { staticClass: "ash" }, [_vm._v("Item Total")]),
            _vm._v(" "),
            _c("span", [_vm._v("$" + _vm._s(_vm.serviceOrder.goodsAmount))])
          ]),
          _vm._v(" "),
          _vm.serviceOrder.brandDiscout > 0 ||
          _vm.serviceOrder.shopvidiDiscout > 0
            ? _c("div", [
                _c("span", { staticClass: "ash" }, [_vm._v("Item Dis.")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "$" +
                      _vm._s(
                        (
                          _vm.serviceOrder.brandDiscout +
                          _vm.serviceOrder.shopvidiDiscout
                        ).toFixed(2)
                      )
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "ash" }, [_vm._v("Shipping Fee")]),
            _vm._v(" "),
            _c("span", [_vm._v("$" + _vm._s(_vm.serviceOrder.goodsShipping))])
          ]),
          _vm._v(" "),
          _vm.serviceOrder.goodsShippingDisc > 0
            ? _c("div", [
                _c("span", { staticClass: "ash" }, [_vm._v("Shipping Dis.")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("$" + _vm._s(_vm.serviceOrder.goodsShippingDisc))
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "ash" }, [_vm._v("Quantity Returning")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.serviceOrder.goodsNum))])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "ash" }, [_vm._v("Reason for Return")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.serviceOrder.reasonReturn))])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "ash" }, [_vm._v("Service Order Type")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.getType(_vm.serviceOrder.type)))])
          ]),
          _vm._v(" "),
          _c("div", [
            _c("span", { staticClass: "ash" }, [_vm._v("Product Status")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(_vm.getProductStatus(_vm.serviceOrder.productStatus))
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fc846d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc846d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/service-order/components/refund-details.vue
// module id = 2pri
// module chunks = 2